function initNavbarSearch() {
  // Open/submit logic for nav search
  jQuery(document).on('click', '.mad-navbar__search-submit', function (e) {
    var $form = jQuery(this).closest('form');
    var $navItem = $form.closest('.mad-navbar__nav-item--search');
    var $input = $form.find('.mad-navbar__search-input');
    if (!$input.hasClass('mad-navbar__is-search-open') && $input.val().trim() === '') {
      e.preventDefault();
      $input.addClass('mad-navbar__is-search-open');
      setTimeout(function () { $input.focus(); }, 150);
    } else if ($input.val().trim() === '') {
      e.preventDefault();
      $input.focus();
    }
  });

  // Submit on enter
  jQuery(document).on('keydown', '.mad-navbar__search-input', function (e) {
    if (e.key === 'Enter') {
      var $form = jQuery(this).closest('form');
      var $navItem = $form.closest('.mad-navbar__nav-item--search');
      var $input = $form.find('.mad-navbar__search-input');
      if (!$input.hasClass('mad-navbar__is-search-open')) {
        e.preventDefault();
        $input.addClass('mad-navbar__is-search-open');
        setTimeout(function () { $input.focus(); }, 150);
      } else if ($input.val().trim() === '') {
        e.preventDefault();
        $input.focus();
      }
    }
  });

  jQuery(document).on('click', '.mad-navbar__search-input--icon', function (e) {
    var $searchButton = jQuery('.mad-navbar__search-submit').first();
    if (typeof $searchButton !== 'undefined') { 
      $searchButton.trigger('click');
    }
  });

  // Close search on click outside
  jQuery(document).on('mouseup', function (e) {
    var $openInput = jQuery('.mad-navbar__search-input.mad-navbar__is-search-open');
    if ($openInput.length && !$openInput.is(e.target) && $openInput.has(e.target).length === 0 && !jQuery(e.target).hasClass('mad-navbar__search-submit')) {
      $openInput.removeClass('mad-navbar__is-search-open');
    }
  });
}

jQuery(document).ready(() => {
    initNavbarSearch();
});